export const config = {
    apiKey: 'AIzaSyDlJdzC3FnUAJoQT4EPlBueKxwVYqQQ9zk',
    authDomain: 'denticalc-demo.firebaseapp.com',
    databaseURL: 'https://denticalc-demo.firebaseio.com',
    projectId: 'denticalc-demo',
    storageBucket: 'denticalc-demo.appspot.com',
    messagingSenderId: '443467291494',
    appId: '1:443467291494:web:2012e40243e66bb51906a7',
    measurementId: 'G-WRETJT8GVG',
};
